import type { YinshConfig } from "../types/game-config";

export const DEFAULT_CONFIG: YinshConfig = {
  ringsPerPlayer: 5,
  markersTotal: 51,
  ringsToWin: 3,
  rowLength: 5,
};
